import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Projects() {

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      fetch("/api/admin/projects/projects.php")
        .then(res => res.json())
        .then(data => {
          setProjects(data);
          setLoading(false);
        })
        .catch(err => {
          console.error("Erreur chargement projets", err);
          setLoading(false);
        });
    }, []);

    if (loading) {
      return (
        <section className="py-5 text-center">
          <p>Chargement des projets…</p>
        </section>
      );
    }

  return (
    <section id="projects">
            <div className="projects-column">
            {projects.map((p, i) => (
              <Link key={i} className="project-wrapper" to={`/projects/${p.id}`}>
                  <div
                    className="project-card"
                    style={{ backgroundImage: 'url(' + p.image + ')'}}
                  >
                    <div className="project-overlay">

                      <h3
                        className="display-4"
                        style={{ fontFamily: "pangram-sans-semiBold" }}
                      >
                        {p.title.toUpperCase()}
                      </h3>
                      <h5
                        style={{ marginLeft:'15%', fontFamily: "pangram-eiko-lightItalic", letterSpacing:'0.5px'}}
                      >
                        {p.desc}
                      </h5>
                    </div>
                  </div>
              </Link>
              ))}
            </div>
    </section>
  );
}